module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-for-sale-property-pin-35eef3f6814b436a560d8aa30926f1be.svg";